import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { useToast } from "@hooks"
import { strategiesApi } from "Pages/DsRepricing/Page/@services/api"
import { fromServer } from "Pages/DsRepricing/Page/@services/adapters"
import { dsRepricingDrawerData, dsRepricingOriginalData } from "Pages/DsRepricing/Page/@signals"

export default function useDsRepricingEdit(id) {
	const { showToast } = useToast()
	const isLoading = useSignal(false)

	const onEdit = useCallback(() => {
		isLoading.value = true
		strategiesApi.get(id)
			.then(row => {
				const data = fromServer(row)
				dsRepricingDrawerData.value = data
				dsRepricingOriginalData.value = data
				isLoading.value = false
			})
			.catch(err => {
				isLoading.value = false
				showToast.error(err?.message || "Error loading the strategy")
			})
	}, [id])

	return { onEdit, isLoading: isLoading.value }
}
